import React from 'react';

import './Form.module.css';

const Input = ({ onChange, value, type, ...props }) => {
  return (
    <input
      styleName="input"
      defaultValue={value || ''}
      onBlur={onChange}
      type={type || 'text'}
      {...props}
    />
  );
};

export default Input;
